import { render } from "./FalkenTryeRange.vue?vue&type=template&id=cdd6d4be&ts=true"
import script from "./FalkenTryeRange.vue?vue&type=script&lang=ts"
export * from "./FalkenTryeRange.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__